/**
 * Customer Portal API service
 */
import { getNexusToken, clearNexusToken } from '@/utils/authToken';

const API_BASE = import.meta.env.VITE_API_URL || '';

function getToken(): string | null { return getNexusToken() || null; }
export function setToken(t: string) { localStorage.setItem('nexus_token', t); }
export function clearToken() { clearNexusToken(); }

async function customerFetch<T = unknown>(path: string, opts: RequestInit = {}): Promise<T> {
  const token = getToken();
  if (!token) throw new Error('No autorizado');
  const res = await fetch(`${API_BASE}${path}`, {
    ...opts,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, ...opts.headers },
  });
  const data = await res.json();
  if (res.status === 401) { clearToken(); window.location.href = '/app/login'; throw new Error('Sesión expirada'); }
  if (!res.ok) throw new Error(data.message || data.error || `Error ${res.status}`);
  return data.data ?? data;
}

export async function customerLogin(email: string, password: string) {
  const res = await fetch(`${API_BASE}/api/customer/login`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || data.error || 'Error de autenticación');
  return data.data;
}

export const getCustomerDashboard = () => customerFetch('/api/customer/dashboard');

export const getCustomerRoutes = (params: Record<string, unknown> = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v != null && v !== '') qs.set(k, String(v)); });
  return customerFetch(`/api/customer/routes?${qs}`);
};

export const getCustomerRouteDetail = (id: string) => customerFetch(`/api/customer/routes?id=${id}`);

export const getCustomerBilling = (params: Record<string, unknown> = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v != null && v !== '') qs.set(k, String(v)); });
  return customerFetch(`/api/customer/billing?${qs}`);
};

export const getCustomerProfile = () => customerFetch('/api/customer/profile');

export const updateCustomerProfile = (data: Record<string, unknown>) =>
  customerFetch('/api/customer/profile', { method: 'PUT', body: JSON.stringify(data) });

export const changeCustomerPassword = (current_password: string, new_password: string) =>
  customerFetch('/api/customer/profile', { method: 'POST', body: JSON.stringify({ action: 'change-password', current_password, new_password }) });
